<div class="container">
    <h3>Edit Profile</h3>
</div>

<div class="container">
    <div class="row">
        <!-- <div class="col-lg-3 col-md-3 col-sm-4 col-xs-12">
            <span class="user-icon"><i class="bi bi-person"></i></span>
        </div> -->
        <div class="col-lg-9 col-md-9 col-sm-8 col-xs-12">
            <table class="table">
                <tbody [formGroup]="doctorForm">
                    <!-- <tr>
                    <td>Register Date</td>
                    <td>:</td>
                    <td><input type="text" name="Register" formControlName="registerDate" disabled></td>
                </tr> -->
                    <tr>
                        <td>First Name</td>
                        <td>:</td>
                        <td><input type="text" name="username" class="form-control" formControlName="firstName">
                            <div
                                *ngIf="doctorForm.get('firstName').hasError('required') && doctorForm.get('firstName').touched">
                                <small class="error">Firstname should not be empty</small>
                            </div>
                            <div
                                *ngIf="doctorForm.get('firstName').hasError('minlength')&& doctorForm.get('firstName').touched">
                                <small class="error">Firstname should contain minimum 3 characters</small>
                            </div>
                            <div
                                *ngIf="doctorForm.get('firstName').hasError('maxlength')&& doctorForm.get('firstName').touched">
                                <small class="error">Firstname should contain maximum 35 characters</small>
                            </div>
                            <div
                                *ngIf="doctorForm.get('firstName').hasError('pattern')&& doctorForm.get('firstName').touched">
                                <small class="error">Please enter only alphabets</small>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Last Name</td>
                        <td>:</td>
                        <td><input type="text" name="username" formControlName="lastName" class="form-control">
                            <div
                                *ngIf="doctorForm.get('lastName').hasError('required') && doctorForm.get('lastName').touched">
                                <small class="error">Lastname should not be empty</small>
                            </div>
                            <div
                                *ngIf="doctorForm.get('lastName').hasError('minlength')&& doctorForm.get('lastName').touched">
                                <small class="error">Lastname should contain minimum 3 characters</small>
                            </div>
                            <div
                                *ngIf="doctorForm.get('lastName').hasError('maxlength')&& doctorForm.get('lastName').touched">
                                <small class="error">Lastname should contain maximum 35 characters</small>
                            </div>
                            <div
                                *ngIf="doctorForm.get('lastName').hasError('pattern')&& doctorForm.get('lastName').touched">
                                <small class="error">Please enter only alphabets</small>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Gender</td>
                        <td>:</td>
                        <td><select name="Gender" formControlName="genderId" class="form-control">
                                <option value="null" disabled>select</option>
                                <ng-container *ngFor="let gender of gender">
                                    <option value="{{gender?.genderId}}">{{gender?.genderName}}</option>
                                </ng-container>
                            </select>
                            <div
                                *ngIf="doctorForm.get('genderId').hasError('required')&& doctorForm.get('genderId').touched">
                                <small class="error">Please select gender</small>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>DOB</td>
                        <td>:</td>
                        <td><input type="date" id="myDate" class="form-control" max="{{maxdate| date:'yyyy-MM-dd'}}" formControlName="dob">

                            <div *ngIf="doctorForm.get('dob').hasError('required')&& doctorForm.get('dob').touched">
                                <small class="error">Please enter the date of birth</small>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Email </td>
                        <td>:</td>
                        <td><input type="email" name="email"class="form-control" formControlName="email" disabled></td>
                    </tr>
                    <tr>
                        <td>Country</td>
                        <td>:</td>
                        <td>
                            <select id="country" class="form-control" formControlName="country"
                                (change)="getState($event.target.value)">
                                <option value="" disabled>Select Country</option>
                                <option *ngFor="let country of countries" value="{{country?.countryId}}">
                                    {{country.countryName}}</option>
                            </select>
                            <div
                                *ngIf="doctorForm.get('country').hasError('required')&& doctorForm.get('country').touched">
                                <small class="error">Please select country</small>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>State</td>
                        <td>:</td>
                        <td>
                            <select id="state" class="form-control" formControlName="state" 
                                (change)="getCity($event.target.value)">
                                <option value="">Select State</option>
                                <!--<option value="null"></option> *ngIf="showDisabled">Select Country</option>-->
                                <option *ngFor="let state of states" value="{{state.stateId}}">{{state.stateName}}
                                </option>
                            </select>
                            <div
                                *ngIf="doctorForm.get('country').hasError('required')&& doctorForm.get('state').touched;else selectState">
                                <small class="error">Please first select country</small>
                            </div>
                            <ng-template #selectState>
                                <div
                                    *ngIf="doctorForm.get('state').hasError('required')&& doctorForm.get('state').touched">
                                    <small class="error">Please select state</small>
                                </div>
                            </ng-template>
                        </td>
                    </tr>
                    <tr>
                        <td>City</td>
                        <td>:</td>
                        <td>
                            <select id="city" class="form-control" formControlName="city">
                                <option value="">Select City</option>
                                <!--<option value="null" *ngIf="showDisabled">Select Country</option>-->
                                <option *ngFor="let city of cities" value="{{city.cityId}}">{{city.cityName}}</option>
                            </select>
                            <div
                                *ngIf="doctorForm.get('state').hasError('required')&& doctorForm.get('city').touched;else selectCity">
                                <small class="error">Please first select state</small>
                            </div>
                            <ng-template #selectCity>
                                <div
                                    *ngIf="doctorForm.get('city').hasError('required') && doctorForm.get('city').touched">
                                    <small class="error">Please select city</small>
                                </div>
                            </ng-template>
                        </td>
                    </tr>
                    <tr>
                        <td>Phone Number</td>
                        <td>:</td>
                        <td><input type="text" class="form-control" formControlName="mobile">
                            <div
                                *ngIf="doctorForm.get('mobile').hasError('required')&& doctorForm.get('mobile').touched">
                                <small class="error">Please enter phone number</small>
                            </div>
                            <div
                                *ngIf="doctorForm.get('mobile').hasError('pattern')&& doctorForm.get('mobile').touched;else test">
                                <small class="error">Please enter in digits</small>
                            </div>
                            <ng-template #test>
                                <div
                                    *ngIf="doctorForm.get('mobile').hasError('minlength')&& doctorForm.get('mobile').touched">
                                    <small class="error">Please enter minimum 10 digits</small>
                                </div>
                                <div
                                    *ngIf="doctorForm.get('mobile').hasError('maxlength')&& doctorForm.get('mobile').touched">
                                    <small class="error">Please enter maximum 10 digits</small>
                                </div>
                            </ng-template>
                        </td>
                    </tr>
                    <tr>
                        <td>Address</td>
                        <td>:</td>
                        <td><textarea rows="3" cols="50"  class="form-control"formControlName="addrLine1">
                    </textarea>
                            <div
                                *ngIf="doctorForm.get('addrLine1').hasError('required')&& doctorForm.get('addrLine1').touched">
                                <small class="error">Please enter address</small>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td>Languages known to speak</td>
                        <td>:</td>
                        <td>
                            <ng-multiselect-dropdown [placeholder]="'Languages known to speak'"
                                [settings]="ddSettingsToSpeak" [data]="languageList"
                                formControlName="languagesKnownSpeak" class="multiselect-dropdown">
                            </ng-multiselect-dropdown>
                            <div
                                *ngIf="doctorForm.get('languagesKnownSpeak').hasError('required')&& doctorForm.get('languagesKnownSpeak').touched">
                                <small class="error">Please select the language known</small>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Languages known to Read Write</td>
                        <td>:</td>
                        <td>
                            <ng-multiselect-dropdown [placeholder]="'Languages known to read write'"
                                [settings]="ddSettingsToSW" [data]="languageList"
                                formControlName="languagesKnownReadWrite" class="multiselect-dropdown">
                            </ng-multiselect-dropdown>
                            <div
                                *ngIf="doctorForm.get('languagesKnownReadWrite').hasError('required')&& doctorForm.get('languagesKnownReadWrite').touched">
                                <small class="error">Please select the language known</small>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Graduation</td>
                        <td>:</td>
                        <td><input type="text" formControlName="graduatedegree" class="form-control">
                            <div
                                *ngIf="doctorForm.get('graduatedegree').hasError('required')&& doctorForm.get('graduatedegree').touched">
                                <small class="error">Please fill the field</small>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Postgraduation</td>
                        <td>:</td>
                        <td><input type="text" formControlName="postgraduatedegree" class="form-control"></td>
                    </tr>
                    <tr>
                        <td>Specialities</td>
                        <td>:</td>
                        <td>
                            <ng-multiselect-dropdown [settings]="ddSettingToSpecilities" [data]="specaiality_list"
                                formControlName="doctorSpecialities" class="multiselect-dropdown">
                            </ng-multiselect-dropdown>
                            <div
                                *ngIf="doctorForm.get('doctorSpecialities').hasError('required')&& doctorForm.get('doctorSpecialities').touched">
                                <small class="error">Please select the speciality</small>
                            </div>
                        </td>
                    </tr>
                    <tr [formGroup]=setTimings>
                        <td>Available-Start-Time</td>
                        <td>:</td>
                        <td><input type="text" class="form-control" [min]="startAt" [max]="endAt"
                                [owlDateTime]="starttime" [owlDateTimeTrigger]="starttime" name="AvailableStartTime"
                                placeholder="Start Time" formControlName="startTime"
                                (dateTimeChange)="changeTime('availabilityStartTime')">
                            <owl-date-time [pickerType]="'timer'" [startAt]="getTime" [hour12Timer]=true
                                [stepMinute]='60' #starttime>
                            </owl-date-time>
                            <div
                                *ngIf="setTimings.get('startTime').hasError('required')&& setTimings.get('startTime').touched">
                                <small class="error">Please select the availability start time</small>
                            </div>
                            <div
                                *ngIf="setTimings.get('startTime').hasError('greaterValue')&& setTimings.get('startTime').touched">
                                <small class="error">Start-time must be less than End-time </small>
                            </div>
                            <!-- <div *ngIf="checkTime">
                                <small class="error">Start-time must be less than End-time</small>
                            </div> -->
                        </td>
                    </tr>
                    <tr [formGroup]=setTimings>
                        <td>Available-End-Time</td>
                        <td>:</td>
                        <td><input type="text" class="form-control" placeholder="End Time" name="AvailableEndTime"
                                [min]="startAt" [max]="endAt" formControlName="endTime"
                                (dateTimeChange)="changeTime('availabilityEndTime')" [owlDateTime]="endtime"
                                [owlDateTimeTrigger]="endtime">
                            <owl-date-time [pickerType]="'timer'" [stepMinute]='60' [hour12Timer]=true
                                [startAt]="getTime1" #endtime>
                            </owl-date-time>
                            <div
                                *ngIf="setTimings.get('endTime').hasError('required')&& setTimings.get('endTime').touched">
                                <small class="error">Please select the closed end time</small>
                            </div>
                        </td>
                    </tr>
                    <!-- <tr>
                        <td>Experience </td>
                        <td>:</td>
                        <td><input type="text" formControlName="experienceFrom" class="form-control"></td>
                    </tr> -->
                </tbody>
            </table>
        </div>
    </div>
    <!-- <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 certificate">
            <div>
                <h5>Certificates :</h5>
            </div>
            <span class="glyphicon glyphicon-picture"></span>
            <span class="glyphicon glyphicon-picture"></span>
            <span class="glyphicon glyphicon-picture"></span>
            <span class="glyphicon glyphicon-picture"></span>
        </div>
    </div> -->
</div>
<div class="container buttons">
    <button type="button" class="bb" (click)="updateProfile()">Save</button>
    <button type="button" class="bb2" routerLink="/products">Cancel</button>
</div>


<ng-template #msg>
    <!-- Modal Header -->
    <div class="modal-header">
        <h4 class="modal-title">Message</h4>
        <button type="button" class="closeModal" data-dismiss="modal" (click)="modalClose()"><i
                class="bi bi-x-circle"></i></button>
    </div>
    <!-- Modal body -->
    <div class="modal-body">
        <p class="text-center">{{modal.config.initialState.message}}</p>
    </div>
    <!-- Modal footer -->
    <div class="modal-footer">
        <!-- <button type="button" class="btn btn-danger" (click)="modalClose()">CANCEL</button> -->
        <button type="button" class="btn-blue" (click)="modalClose()"> OK</button>
    </div>
</ng-template>